<script>
  export default {
    props: {
      url: { type: String, required: true },
      nome: { type: String, default: '' },
      tipo: { type: String, default: '' },
    },
    computed: {
      imagem() { return /^image\//.test(this.tipo); },
    },
    mounted() {
      this._tecla = e => { if (e.key === 'Escape') this.$emit('fechar'); };
      document.addEventListener('keydown', this._tecla);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this._tecla);
    },
  };
</script>

<template>
  <div class="vza-ov">
    <div class="vza-janela" role="dialog" aria-modal="true" :aria-label="nome">
      <div class="vza-head">
        <div class="vza-head-ic"><i class="fa" :class="imagem ? 'fa-picture-o' : 'fa-file-pdf-o'"></i></div>
        <div class="vza-head-txt" :title="nome">{{ nome }}</div>
      </div>
      <div class="vza-corpo" :class="{ 'vza-corpo-img': imagem }">
        <img v-if="imagem" :src="url" :alt="nome">
        <iframe v-else :src="url" :title="nome"></iframe>
      </div>
      <div class="vza-foot">
        <button type="button" class="vza-btn vza-baixar" @click="$emit('baixar')"><i class="fa fa-download"></i> Baixar</button>
        <button type="button" class="vza-btn vza-sair" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .vza-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.6); z-index: 2300; display: flex; align-items: center; justify-content: center; padding: 14px; }
  .vza-janela { width: 100%; height: 100%; max-width: 1400px; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.35); overflow: hidden; }
  .vza-head { flex: 0 0 auto; display: flex; align-items: center; gap: 12px; padding: 10px 16px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .vza-head-ic { flex: none; width: 32px; height: 32px; border-radius: 7px; background: #e8f5ef; color: #0a6d4d; display: flex; align-items: center; justify-content: center; font-size: 16px; }
  .vza-head-txt { flex: 1 1 auto; min-width: 0; font-size: 14px; font-weight: 600; color: #1c2024; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .vza-corpo { flex: 1 1 auto; min-height: 0; background: #525659; }
  .vza-corpo iframe { display: block; width: 100%; height: 100%; border: none; background: #525659; }
  .vza-corpo-img { display: flex; align-items: center; justify-content: center; overflow: auto; padding: 12px; }
  .vza-corpo-img img { max-width: 100%; max-height: 100%; object-fit: contain; background: #fff; box-shadow: 0 4px 18px rgba(0,0,0,.35); }
  .vza-foot { flex: 0 0 auto; display: flex; justify-content: flex-end; gap: 8px; padding: 10px 16px; border-top: 1px solid #e6eaee; background: #fff; }
  .vza-btn { display: inline-flex; align-items: center; gap: 7px; border-radius: 5px; padding: 8px 18px; font-size: 12.5px; font-weight: 600; border: 1px solid transparent; }
  .vza-baixar { background: #f1f7f4; border-color: #cfe6da; color: #0a6d4d; }
  .vza-baixar:hover { background: #e3f1ea; }
  .vza-sair { background: #fdf1f1; border-color: #e4d7d7; color: #a13c3c; }
  .vza-sair:hover { background: #fbe6e6; }
</style>



// WEBPACK FOOTER //
// FrontEnd/componentes/VisualizadorArquivo.vue